export const CreditRequestStatus = {
  PENDING: {
    key: 'PENDING',
    label: '대기',
  },
  ACCEPTED: {
    key: 'ACCEPTED',
    label: '승인',
  },
  REJECTED: {
    key: 'REJECTED',
    label: '거절',
  },
};

export type CreditRequestStatusType = keyof typeof CreditRequestStatus;
